import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  ReferenceField,
  SelectField,
  TextField,
  UrlField,
  EditButton,
  CardActions,
  CreateButton,
  ExportButton,
  Filter,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import { docChoices } from './Create';

const OfferDocsListActions = ({
  basePath,
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions>
      {filters && React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      }) }
      { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
        <CreateButton basePath={basePath} /> : undefined
      }
      <ExportButton resource="offeringDocuments" />
    </CardActions>
  );
};

const CanEdit = ({ basePath, record }) => {
  const adminLevel = getAdminLevel();

  if (adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN) {
    return <EditButton basePath={basePath} record={record} />;
  }

  return null;
};


const OfferDocFitler = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Offer"
      source="offerId"
      reference="offerings"
      alwaysOn
      perPage={100}
    >
      <SelectInput />
    </ReferenceInput>
    <SelectInput
      alwaysOn
      label="Document Type"
      source="docType"
      choices={docChoices}
    />
  </Filter>
);

export default props => (
  <List
    {...props}
    actions={<OfferDocsListActions />}
    bulkActionButtons={false}
    filters={<OfferDocFitler />}
    title="Offer Documents"
  >
    <Datagrid>
      <ReferenceField label="Offer" source="offerId" reference="offerings" linkType={false} sortable={false}>
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <SelectField source="docType" choices={docChoices} />
      <UrlField source="url" target="_blank" />
      <CanEdit {...props} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/OfferDocument/List.js